import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { CmsRichText } from "../../../services/cms/cms-type-definitions";
import cms from "../../../services/cms/cms";


export default /*#__PURE__*/_defineComponent({
  __name: 'slide-text',
  props: {
    text: {}
  },
  setup(__props: any) {

const props = __props;
const textHtml = computed(() => cms.asHtml(props.text).replace(/\s/g, " "));

return (_ctx: any,_cache: any) => {
  const _component_CmsTextRenderer = _resolveComponent("CmsTextRenderer")!

  return (_openBlock(), _createBlock(_component_CmsTextRenderer, { html: textHtml.value }, null, 8, ["html"]))
}
}

})